export const sharedServices = {
  getCanList,
  getMfHoldingsUrl
}

function getCanList() {
  var payload = {
    isAjax:true, 
    appType: 'user', 
    pageNum: 1
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/app/v1/dashboard/fetchClients1', requestOptions)
    .then(response => {
      return response.json();
    });
}

function getMfHoldingsUrl() {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    }
  };

  return fetch(process.env.REACT_APP_API_URL + '/holdings/checkout', requestOptions)
    .then(response => {
      return response.json();
    });
}